export default __webpack_public_path__ + "static/experienceImg2-aa39739e47fac1e520fd5fce387985ec.webp";